export default "__VITE_ASSET__DxByaORy__"